// @flow
import React, { Component } from 'react';
import {Link} from "react-router-dom";

class Menu extends Component {

    closeModal(e) {
        let menu =  document.querySelector('.menu'),
            body = document.querySelector('body'),
            menuToggle = document.querySelector('.menu-toggle');
        menu.classList.add('out');
        body.classList.remove('modal-open');
        setTimeout(function(){
            menuToggle.classList.remove('open');
            menu.classList.remove('open')
        },500);
        document.querySelectorAll('.nav-link').forEach((nav) => {
            nav.classList.remove('is-active');
        });
        const navItem = e.target;
        navItem.classList.add('is-active');
    }
    
    render() {
        return (
            <div className="menu modal-container">
                <div className="modal-background">
                    <span className="close"></span>
                    <ul className="nav flex-column modal">
                        <li className="nav-item">
                            <Link className="nav-link" onClick={this.closeModal} to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" onClick={this.closeModal} to="/resume">Resume</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" onClick={this.closeModal} to="/portfolio">Portfolio</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" onClick={this.closeModal} to="/contact">Contact</Link>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}
    
export default Menu;